export default __webpack_public_path__ + "static/media/P-010.ce269e05.png";